export const POLICY_UPDATED = "June 2026";

export const POLICIES = [
  {
    slug: "cancellation",
    title: "Cancellation Policy",
    intro: "These rules apply to every safari, stay and package booked on JawaiTrails.com. All times are India Standard Time (IST) and measured from the scheduled safari departure (or hotel check-in for stays).",
    sections: [
      { h: "Cancelling a booking", p: [
        "You can cancel at any time before your safari starts, either online from Find My Booking (with your booking reference and mobile number) or by writing to info@jawaitrails.com or WhatsApp +91 93753 32211.",
      ], list: [
        "48 hours or more before departure: 100% refund.",
        "Between 24 and 48 hours before departure: 50% refund.",
        "Less than 24 hours before departure, or no-show: no refund.",
      ] },
      { h: "Changing a booking", list: [
        "You can change the date, departure or guest count yourself up to 48 hours before departure, subject to availability.",
        "Changes to an option of the same or lower price are confirmed instantly. Any difference is refunded under this policy.",
        "If the new option costs more, please contact us and we will arrange the balance payment.",
        "The number of jeeps is set automatically at 1 private jeep per 6 guests, so the price may change if your guest count changes.",
        "Within 48 hours of departure, changes are only possible by contacting our team and are not guaranteed.",
      ] },
      { h: "Pay-later bookings", p: [
        "If you choose \"Reserve & pay later\", we hold your jeep or room for 2 hours. Pay online from Find My Booking or pay our team within that time. Unpaid holds are released automatically and there is nothing to refund.",
      ] },
      { h: "Cancellations by us", p: [
        "If we cancel because of forest department orders, unsafe weather, vehicle breakdown or other reasons within our control, you will get a full refund or a free reschedule, whichever you prefer. Wildlife sightings are never guaranteed, so a safari without a leopard sighting is not grounds for a refund.",
      ] },
      { h: "Refund timelines", p: [
        "Approved refunds go back to the original payment method within 5–10 working days. Offline payments (UPI/bank transfer) are refunded to the account they came from. Payment gateway charges, if any, may be deducted.",
      ] },
    ],
  },
  {
    slug: "terms",
    title: "Terms of Service",
    intro: "JawaiTrails.com is operated by Alex Hospitality Services (\"we\", \"us\"). By browsing the site or making a booking you agree to these terms.",
    sections: [
      { h: "Bookings", list: [
        "A booking is confirmed only when payment is received and you get a confirmation email with a voucher.",
        "Safaris are run in private jeeps with up to 6 guests per jeep. Groups larger than 6 are given extra jeeps automatically at the per-jeep price.",
        "Experiences marked \"on request\" (such as sunrise or sundowner outings) are confirmed by our team after you submit a request.",
        "Prices are in Indian Rupees and include the items listed on each safari or stay. Pickup or drop charges for some locations are shown at checkout.",
      ] },
      { h: "On the day", list: [
        "Please be ready at your pickup point at the pickup time on your voucher. Late arrival can shorten the safari and is not refunded.",
        "Carry a government photo ID for every adult. Forest or local authorities may ask to see it.",
        "Children must be accompanied by an adult at all times. Guests with medical conditions or who are pregnant should talk to us before booking, because terrain can be rough.",
        "Our naturalist and driver decide the route and may end a drive early for safety reasons.",
      ] },
      { h: "Your responsibilities", list: [
        "Give accurate guest details and contact information.",
        "Follow the instructions of the naturalist and driver, and the Operator Code of Conduct.",
        "You are responsible for your personal belongings and any damage caused by misconduct.",
      ] },
      { h: "Hotels and partners", p: [
        "Stays are provided by independent hotel partners. Their house rules, check-in times and facilities apply. We act as the booking agent and help resolve any issue you face.",
      ] },
      { h: "Liability", p: [
        "Wildlife safaris carry inherent risks. To the extent allowed by law, our total liability for any booking is limited to the amount you paid for it. We are not liable for delays or cancellations caused by weather, government orders, strikes or other events beyond our control.",
      ] },
      { h: "Governing law", p: [
        "These terms are governed by the laws of India. Courts in Pali, Rajasthan have jurisdiction over any dispute.",
      ] },
    ],
  },
  {
    slug: "privacy",
    title: "Privacy Policy",
    intro: "We collect only what we need to run your booking, and we never sell your data.",
    sections: [
      { h: "What we collect", list: [
        "Booking details: name, email, mobile number, guest count, dates, pickup and drop location, and any notes you add.",
        "Payment confirmation details from our payment partner. We never see or store your card or UPI PIN.",
        "Basic technical data such as IP address and browser type, used for security and to prevent abuse.",
      ] },
      { h: "How we use it", list: [
        "To confirm, manage, change or cancel your booking, and to send vouchers and pickup reminders by email.",
        "To contact you on phone or WhatsApp about your booking or a request you sent.",
        "To share the details needed with the hotel, driver and naturalist serving your booking.",
        "To meet legal, tax and forest department record-keeping requirements.",
      ] },
      { h: "Sharing", p: [
        "We share data only with service providers who help run your booking (hotel partners, payment processor, email delivery) and with authorities when required by law.",
      ] },
      { h: "Retention and security", p: [
        "Booking records are kept for as long as tax and legal rules require, after which they are deleted or anonymised. Data is stored on secured servers, and admin access is restricted and password-protected.",
      ] },
      { h: "Your choices", p: [
        "You can ask for a copy of your data, or ask us to correct or delete it, by writing to info@jawaitrails.com. We reply within 30 days.",
      ] },
    ],
  },
  {
    slug: "code-of-conduct",
    title: "Operator Code of Conduct",
    intro: "Jawai is a living landscape where leopards and Rabari herders have shared the hills for generations. Every JawaiTrails driver, naturalist and partner commits to protecting it, and we ask guests to do the same.",
    sections: [
      { h: "Wildlife first", list: [
        "Keep a respectful distance from leopards and all wildlife. Never chase, surround or block an animal's path.",
        "No baiting, calling, spotlighting or playback to attract animals.",
        "Engines off and voices low at sightings. The jeep stays at a sighting only as long as the animal is relaxed.",
        "No off-track driving in sensitive areas, and we stick to forest department rules and timings.",
      ] },
      { h: "Respect for local communities", list: [
        "Temples, villages, grazing land and herders are not photo props. Always ask before photographing people.",
        "Give way to livestock and herders on every track.",
        "Use local guides, drivers and suppliers wherever possible.",
      ] },
      { h: "Safety and service", list: [
        "Licensed, trained drivers. Jeeps are serviced regularly and carry a first-aid kit.",
        "No more than 6 guests per jeep, and everyone stays seated while the jeep is moving.",
        "No alcohol, smoking or drugs on safari for crew or guests.",
        "Clear, honest pricing with no surprise charges on the day.",
      ] },
      { h: "Leave no trace", list: [
        "Nothing is left behind. All waste comes back with us, and we avoid single-use plastic where we can.",
        "No picking plants, collecting rocks or disturbing nests.",
      ] },
      { h: "Reporting a concern", p: [
        "If any crew member or partner breaks this code, tell us at info@jawaitrails.com or on WhatsApp +91 93753 32211. We take every report seriously and act on it.",
      ] },
    ],
  },
];
